function initFooterScripts() {
  initBackToTop();
}

function initBackToTop() {
  var backToTopButton = document.querySelector('[data-role="back-to-top"]');

  if (!backToTopButton) {
    return;
  }

  backToTopButton.addEventListener('click', function backToTopClick(event) {
    event.preventDefault();
    scrollToTop();
  });
}

function scrollToTop() {
  var distanceToTop = document.documentElement.scrollTop || document.body.scrollTop;

  if (distanceToTop > 0) {
    window.requestAnimationFrame(scrollToTop);
    window.scrollBy(0, -100);
  }
}

export { initFooterScripts };
